import { css } from '@emotion/react';
import { colors } from '@airwallex/global';

const { ultraViolet, ultraViolets, greys } = colors;

export const logoContainerCss = css`
  width: 168px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const logoImgCss = css`
  max-width: 100%;
  max-height: 100%;
`;

export const MenuItemCss = css`
  font-size: 14px;
  font-weight: 500;
  color: ${greys[80]};
  border-radius: 4px;
  margin-left: 8px;
  margin-right: 8px;
  :hover {
    background: ${ultraViolets[10]};
    color: ${ultraViolet};
  }
  :active {
    background: ${ultraViolets[10]};
    color: ${ultraViolet};
  }
`;
